import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[toolTip]',
})

export class TooltipDirective {
    @Input()
    public set toolTip(value) {
        this.el.nativeElement.setAttribute('data-tooltip', value);
    }

    @Input()
    public set toolTipPosition(value: 'left' | 'right' | 'top' | 'bottom') {
        this.el.nativeElement.classList.remove('is-tooltip-top');
        this.el.nativeElement.classList.remove('is-tooltip-left');
        this.el.nativeElement.classList.remove('is-tooltip-right');
        this.el.nativeElement.classList.remove('is-tooltip-bottom');

        this.el.nativeElement.classList.add('is-tooltip-' + value);
    }

    @Input()
    public set toolTipColor(value: 'info' | 'warning' | 'danger' | 'success') {
        this.el.nativeElement.classList.remove('is-tooltip-info');
        this.el.nativeElement.classList.remove('is-tooltip-warning');
        this.el.nativeElement.classList.remove('is-tooltip-danger');
        this.el.nativeElement.classList.remove('is-tooltip-success');

        this.el.nativeElement.classList.add('is-tooltip-' + value);
    }

    @Input()
    public set toolTipIsMultiline(value: boolean) {
        if (value) {
            this.el.nativeElement.classList.add('is-tooltip-multiline');
        } else {
            this.el.nativeElement.classList.remove('is-tooltip-multiline');
        }
    }

    constructor(private readonly el: ElementRef) {
        this.el.nativeElement.classList.add('tooltip');
    }
}
